import { api, specApi } from './request'

const requestApi = {
  queryOrderTruckInfoList: '/orderTruck/queryOrderTruckInfoList',
  queryOrderTruckInfoDetail: '/orderTruck/queryOrderTruckInfoDetail',
  queryOrderTruckInfoGoodsDetailInfo: '/orderTruck/queryOrderTruckInfoGoodsDetailInfo',
  updateOrderTruckInfoGoodsDetail: '/orderTruck/updateOrderTruckInfoGoodsDetail',
  queryOrderTruckInvoiceList: '/orderTruck/queryOrderTruckInvoiceList',
  pushOrderTruckInfoGoodsDetail: '/orderTruck/pushOrderTruckInfoGoodsDetail',
  queryOrderTruckInfoContract: '/orderTruck/queryOrderTruckInfoContract',
  saveOrderTruckInfoContract: '/orderTruck/saveOrderTruckInfoContract',
  queryAssignTruckList: '/orderTruck/queryAssignTruckList',
  cancelTruckDispatch: '/orderTruck/cancelTruckDispatch',
  dispatchOrderTruck: '/orderTruck/dispatchOrderTruck',
  changeDispatchOrderTruck: '/orderTruck/changeDispatchOrderTruck',
  queryTruckDriverRouteList: '/orderTruck/queryTruckDriverRouteList',
  cancelOrderTruckInfo: '/orderTruck/cancelOrderTruckInfo',
  querySelectAssignTruckList: '/orderTruck/querySelectAssignTruckList',
  updateOrderTruckInfoInsurance: '/orderTruck/updateOrderTruckInfoInsurance',
  queryOrderTruckInfoCost: '/orderTruck/queryOrderTruckInfoCost',

  // 用户认证管理
  listTruckFleetInfo: '/driver/listTruckFleetInfo',
  freezeTruckFleet: '/driver/freezeTruckFleet',
  getTruckFleetInfoDetail: '/driver/getTruckFleetInfoDetail',
  editBaseFleetInfo: '/driver/editBaseFleetInfo',
  editFleetQualification: '/driver/editFleetQualification',
  editFleetBankInfo: '/driver/editFleetBankInfo',
  listTruckFleetInfo: '/driver/listTruckFleetInfo',
  listTruckDriver: '/driver/listTruckDriver',
  queryTruckDriverDetailById: '/driver/queryTruckDriverDetailById',
  editBaseTruckDriverFromFleet: '/driver/editBaseTruckDriverFromFleet',
  editDriverQualificationFromFleet: '/driver/editDriverQualificationFromFleet',
  addTruckInfo: '/driver/addTruckInfo',
  checkLicensePlateNumber: '/driver/checkLicensePlateNumber',
  editTruckInfo: '/driver/editTruckInfo',
  queryFleetNameList: '/driver/queryFleetNameList',
  getTruckDriverById: '/driver/getTruckDriverById',
  queryTruckInfoList: '/driver/queryTruckInfoList',
  freezeTruck: '/driver/freezeTruck',
  getTruckInfoDetailById: '/driver/getTruckInfoDetailById',
  editBaseTruckDriver: '/driver/editBaseTruckDriver',
  editDriverQualification: '/driver/editDriverQualification',
  editBankCardInfo: '/driver/editBankCardInfo',
  editAdditionalInfo: '/driver/editAdditionalInfo',
  queryJoinFleets: '/driver/queryJoinFleets',
  joinFleet: '/driver/joinFleet',
  freezeTruckDriver: '/driver/freezeTruckDriver',
  queryBindTrucks: '/driver/queryBindTrucks',
  bindTruck: '/driver/bindTruck',
  checkIdCardInFleetOrDriver: '/driver/checkIdCardInFleetOrDriver',
  getFleetOrDriverByPhone: '/driver/getFleetOrDriverByPhone',
  addTruckDriver: '/driver/addTruckDriver',
  editTruckDriver: '/driver/editTruckDriver',
  getTruckDriverEditById: '/driver/getTruckDriverEditById',
  appqueryOrderTruckInfoTrajectory: '/app/driver/orderTruck/queryOrderTruckInfoTrajectory',

  // 网路货运上报
  queryWaybillReportList: '/nfreport/queryWaybillReportList',
  queryFundFlowReportList: '/nfreport/queryFundFlowReportList',
  updateTruckOrderReportStatus: '/nfreport/updateTruckOrderReportStatus',
  updateReceivablePayableReportStatus: '/nfreport/updateReceivablePayableReportStatus',

  queryOrderTruckGoodsAuditList: '/orderTruck/queryOrderTruckGoodsAuditList', //查询货源单审核列表
  queryOrderTruckGoodsAuditDetail: '/orderTruck/queryOrderTruckGoodsAuditDetail', //查询货源单审核详情
  auditOrderTruckGoods: '/orderTruck/auditOrderTruckGoods', //审核货源单

  queryOrderTruckGoodsList: '/orderTruck/queryOrderTruckGoodsList', //查询货源单管理列表
  queryOrderTruckGoodsDetail: '/orderTruck/queryOrderTruckGoodsDetail', //查询货源单详情
  receiveOrderTruckGoods: '/orderTruck/receiveOrderTruckGoods', //货源立即接单
  queryOrderTruckInfoTrajectory: '/orderTruck/queryOrderTruckInfoTrajectory',
  queryContractBaseOrderTruckInfo: '/orderTruck/queryContractBaseOrderTruckInfo',

  queryBaseDictionaryList: '/common/queryBaseDictionaryList', //数据字典列表
  addBaseDictionary: '/common/addBaseDictionary', //新增
  editBaseDictionary: '/common/editBaseDictionary', //编辑
  checkDictionaryExist: '/common/checkDictionaryExist', //存在校验
  removeBaseDictionary: '/common/removeBaseDictionary', //删除
  queryOrderTruckCargoDriver: '/orderTruck/queryOrderTruckCargoDriver', //查询货主指定司机
}
export default requestApi

export const queryOrderTruckGoodsAuditList = (data) => api(requestApi.queryOrderTruckGoodsAuditList, data)
export const queryOrderTruckGoodsAuditDetail = (data) => api(requestApi.queryOrderTruckGoodsAuditDetail, data)
export const auditOrderTruckGoods = (data) => api(requestApi.auditOrderTruckGoods, data)

export const queryOrderTruckGoodsList = (data) => api(requestApi.queryOrderTruckGoodsList, data)
export const queryOrderTruckGoodsDetail = (data) => api(requestApi.queryOrderTruckGoodsDetail, data)
export const receiveOrderTruckGoods = (data) => api(requestApi.receiveOrderTruckGoods, data)

export const addBaseDictionary = (data) => api(requestApi.addBaseDictionary, data)
export const editBaseDictionary = (data) => api(requestApi.editBaseDictionary, data)
export const checkDictionaryExist = (data) => api(requestApi.checkDictionaryExist, data)
export const removeBaseDictionary = (data) => api(requestApi.removeBaseDictionary, data)

export const queryOrderTruckInfoList = (data) => api(requestApi.queryOrderTruckInfoList, data)
export const queryOrderTruckInfoDetail = (data) => api(requestApi.queryOrderTruckInfoDetail, data)
export const queryOrderTruckInfoGoodsDetailInfo = (data) => api(requestApi.queryOrderTruckInfoGoodsDetailInfo, data)
export const updateOrderTruckInfoGoodsDetail = (data) => api(requestApi.updateOrderTruckInfoGoodsDetail, data)
export const queryOrderTruckInvoiceList = (data) => api(requestApi.queryOrderTruckInvoiceList, data)
export const pushOrderTruckInfoGoodsDetail = (data) => api(requestApi.pushOrderTruckInfoGoodsDetail, data)
export const queryOrderTruckInfoContract = (data) => api(requestApi.queryOrderTruckInfoContract, data)
export const saveOrderTruckInfoContract = (data) => api(requestApi.saveOrderTruckInfoContract, data)
export const queryAssignTruckList = (data) => api(requestApi.queryAssignTruckList, data)
export const cancelTruckDispatch = (data) => api(requestApi.cancelTruckDispatch, data)
export const dispatchOrderTruck = (data) => api(requestApi.dispatchOrderTruck, data)
export const changeDispatchOrderTruck = (data) => api(requestApi.changeDispatchOrderTruck, data)
export const queryTruckDriverRouteList = (data) => api(requestApi.queryTruckDriverRouteList, data)
export const cancelOrderTruckInfo = (data) => api(requestApi.cancelOrderTruckInfo, data)
export const querySelectAssignTruckList = (data) => api(requestApi.querySelectAssignTruckList, data)

export const queryBaseDictionaryList = (data) => api(requestApi.queryBaseDictionaryList, data)
export const queryWaybillReportList = (data) => api(requestApi.queryWaybillReportList, data)
export const queryFundFlowReportList = (data) => api(requestApi.queryFundFlowReportList, data)
export const updateTruckOrderReportStatus = (data) => api(requestApi.updateTruckOrderReportStatus, data)
export const updateReceivablePayableReportStatus = (data) => api(requestApi.updateReceivablePayableReportStatus, data)
export const updateOrderTruckInfoInsurance = (data) => api(requestApi.updateOrderTruckInfoInsurance, data)
export const queryOrderTruckInfoCost = (data) => api(requestApi.queryOrderTruckInfoCost, data)
export const queryOrderTruckInfoTrajectory = (data) => api(requestApi.queryOrderTruckInfoTrajectory, data)
export const queryContractBaseOrderTruckInfo = (data) => api(requestApi.queryContractBaseOrderTruckInfo, data)
export const queryOrderTruckCargoDriver = (data) => api(requestApi.queryOrderTruckCargoDriver, data)

export const listTruckFleetInfo = (data) => specApi(requestApi.listTruckFleetInfo, data)
export const freezeTruckFleet = (data) => specApi(requestApi.freezeTruckFleet, data)
export const getTruckFleetInfoDetail = (data) => specApi(requestApi.getTruckFleetInfoDetail, data)
export const editBaseFleetInfo = (data) => specApi(requestApi.editBaseFleetInfo, data)
export const editFleetQualification = (data) => specApi(requestApi.editFleetQualification, data)
export const editFleetBankInfo = (data) => specApi(requestApi.editFleetBankInfo, data)
export const listTruckDriver = (data) => specApi(requestApi.listTruckDriver, data)
export const queryTruckDriverDetailById = (data) => specApi(requestApi.queryTruckDriverDetailById, data)
export const editBaseTruckDriverFromFleet = (data) => specApi(requestApi.editBaseTruckDriverFromFleet, data)
export const editDriverQualificationFromFleet = (data) => specApi(requestApi.editDriverQualificationFromFleet, data)
export const addTruckInfo = (data) => specApi(requestApi.addTruckInfo, data)
export const checkLicensePlateNumber = (data) => specApi(requestApi.checkLicensePlateNumber, data)
export const editTruckInfo = (data) => specApi(requestApi.editTruckInfo, data)
export const queryFleetNameList = (data) => specApi(requestApi.queryFleetNameList, data)
export const getTruckDriverById = (data) => specApi(requestApi.getTruckDriverById, data)
export const queryTruckInfoList = (data) => specApi(requestApi.queryTruckInfoList, data)
export const freezeTruck = (data) => specApi(requestApi.freezeTruck, data)
export const getTruckInfoDetailById = (data) => specApi(requestApi.getTruckInfoDetailById, data)
export const editBaseTruckDriver = (data) => specApi(requestApi.editBaseTruckDriver, data)
export const editDriverQualification = (data) => specApi(requestApi.editDriverQualification, data)
export const editBankCardInfo = (data) => specApi(requestApi.editBankCardInfo, data)
export const editAdditionalInfo = (data) => specApi(requestApi.editAdditionalInfo, data)
export const queryJoinFleets = (data) => specApi(requestApi.queryJoinFleets, data)
export const joinFleet = (data) => specApi(requestApi.joinFleet, data)
export const freezeTruckDriver = (data) => specApi(requestApi.freezeTruckDriver, data)
export const queryBindTrucks = (data) => specApi(requestApi.queryBindTrucks, data)
export const bindTruck = (data) => specApi(requestApi.bindTruck, data)
export const checkIdCardInFleetOrDriver = (data) => specApi(requestApi.checkIdCardInFleetOrDriver, data)
export const getFleetOrDriverByPhone = (data) => specApi(requestApi.getFleetOrDriverByPhone, data)
export const addTruckDriver = (data) => specApi(requestApi.addTruckDriver, data)
export const editTruckDriver = (data) => specApi(requestApi.editTruckDriver, data)
export const getTruckDriverEditById = (data) => specApi(requestApi.getTruckDriverEditById, data)

export const appqueryOrderTruckInfoTrajectory = (data) => specApi(requestApi.appqueryOrderTruckInfoTrajectory, data)


// WEBPACK FOOTER //
// ./src/api/landCenter.js